export default "__VITE_ASSET__QOMnalLI__"